import React from 'react';
import { Button, Card } from '@douyinfe/semi-ui';
import Title from '@douyinfe/semi-ui/lib/es/typography/title';
import Text from '@douyinfe/semi-ui/lib/es/typography/text';
import { Link } from 'react-router-dom';
import { IconHome } from '@douyinfe/semi-icons';

const NotFound = () => (
  <div style={{ 
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
    background: '#f5f7fa'
  }}>
    <Card style={{ 
      maxWidth: '500px',
      width: '100%',
      textAlign: 'center',
      boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
      borderRadius: '4px',
      border: '1px solid #e4e7ed'
    }}>
      <div style={{ padding: '40px 32px' }}>
        {/* 404 图标 */}
        <div style={{ 
          fontSize: '120px', 
          fontWeight: 'bold',
          color: '#e4e7ed',
          lineHeight: 1,
          marginBottom: '24px'
        }}>
          404
        </div>
        
        {/* 标题 */}
        <Title heading={3} style={{ 
          margin: '0 0 12px 0',
          color: '#303133'
        }}>
          页面不存在
        </Title>
        
        {/* 描述 */}
        <Text style={{ 
          color: '#909399',
          fontSize: '14px',
          lineHeight: '1.6',
          display: 'block',
          marginBottom: '32px'
        }}>
          抱歉，您访问的页面不存在或已被移除
        </Text>
        
        {/* 按钮组 */}
        <div style={{ 
          display: 'flex',
          gap: '16px',
          justifyContent: 'center'
        }}>
          <Link to='/'>
            <Button 
              theme="solid"
              icon={<IconHome />}
              style={{ 
                background: '#409eff',
                border: 'none',
                height: '40px',
                padding: '0 24px',
                fontSize: '14px',
                fontWeight: '500',
                borderRadius: '4px'
              }}
            >
              返回首页
            </Button>
          </Link>
          <Button 
            theme="borderless"
            onClick={() => window.history.back()}
            style={{ 
              height: '40px',
              padding: '0 24px',
              fontSize: '14px',
              fontWeight: '500',
              borderRadius: '4px',
              border: '1px solid #dcdfe6',
              color: '#606266'
            }}
          >
            返回上一页
          </Button>
        </div>
      </div>
    </Card>
  </div>
);

export default NotFound;
